<div class="container">
  <div class="header">
    <pdq-heading element="h3">{{ title }}</pdq-heading>
    <pdq-button
      (onClick)="dialogRef.close()"
      iconColor="var(--on-surface-light)"
      variant="ghost"
      icon="close"></pdq-button>
  </div>
  <div class="wrapper">
    <div class="content">
      {{ body }}
      @if (runningAbTestNames.length > 0) {
        <div class="banner">
          <pdq-banner
            variant="attention"
            class="banner"
            bannerTitle="Please note: To upgrade to AB Test V2, all running tests in V1 must be concluded. Ensure all active tests are stopped to smoothly transition to the enhanced V2 platform. You currently have tests running for the following shipping methods"
            [content]="runningAbTestNames"
            [closable]="false">
          </pdq-banner>
        </div>
      }
    </div>
  </div>
  <footer>
    <pdq-button label="Cancel" (onClick)="dialogRef.close()"></pdq-button>
    <pdq-button
      variant="primary"
      label="Upgrade"
      (onClick)="confirm($event)"
      [disabled]="runningAbTestNames.length > 0"></pdq-button>
  </footer>
</div>
